// extracted by mini-css-extract-plugin
module.exports = {"root":"PatientQuestionnaire_root__nhVJG","header":"PatientQuestionnaire_header__1vngj","info":"PatientQuestionnaire_info__2e5zN"};